import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { WhoWeHelpPageBG } from "@/components/site/WhoWeHelpPageBG";
import { WHO_WE_HELP_META_DESCRIPTION_BG } from "@/content/meta/WhoWeHelpPageBG";

export const Route = createFileRoute("/bg/who-we-help/")({
  head: () => ({
    meta: [
      { title: "Кого подкрепяме - клиенти за медийно разузнаване | Perceptica" },
      { name: "description", content: WHO_WE_HELP_META_DESCRIPTION_BG },
      { property: "og:title", content: "Кого подкрепяме - клиенти за медийно разузнаване | Perceptica" },
      { property: "og:description", content: WHO_WE_HELP_META_DESCRIPTION_BG },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Кого подкрепяме - клиенти за медийно разузнаване | Perceptica" },
      { name: "twitter:description", content: WHO_WE_HELP_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/who-we-help" },
      ...ogImageMeta("bg", "/who-we-help"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/who-we-help/index" }),
  }),
  component: WhoWeHelpPageBG,
});
